import React from 'react';
import PropTypes from 'prop-types';

import { accountRoutes, CLIENT_PROFILE_COMPONENT_TYPES, clientProfileRoutes } from '@atlas/routing';

import ClientProfileSubRouter from 'components/ClientProfile/ClientProfileSubRouter';

import AccountNumbers from './AccountNumbers/AccountNumbers';
import Verification from './Verification/Verification';
import ChangePassword from './ChangePassword';
import FinancialReport from './FinancialReport';
import ProfileMain from './ProfileMain';

const { profile } = clientProfileRoutes;

const { accountNumbers, changePassword, financialReport, main, verifyDocuments } = accountRoutes;

const getAvailableRoutes = clientProfilePath => ({
  [CLIENT_PROFILE_COMPONENT_TYPES.PROFILE_MAIN]: {
    component: ProfileMain,
    path: `${clientProfilePath}/${profile}/${main}`,
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.PROFILE_CHANGE_PASSWORD]: {
    component: ChangePassword,
    path: `${clientProfilePath}/${profile}/${changePassword}`,
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.PROFILE_VERIFY]: {
    component: Verification,
    path: `${clientProfilePath}/${profile}/${verifyDocuments}`,
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.PROFILE_ACCOUNT_NUMBERS]: {
    component: AccountNumbers,
    path: `${clientProfilePath}/${profile}/${accountNumbers}`,
  },
  [CLIENT_PROFILE_COMPONENT_TYPES.PROFILE_FINANCIAL_REPORT]: {
    component: FinancialReport,
    path: `${clientProfilePath}/${profile}/${financialReport}`,
  },
});

const ProfileRouter = ({ tabs = [] }) => (
  <ClientProfileSubRouter
    getAvailableRoutes={getAvailableRoutes}
    parentRoute={profile}
    tabs={tabs}
  />
);

ProfileRouter.propTypes = { tabs: PropTypes.array };

export default ProfileRouter;
